const PITCH_OFFSET = -4;
const ENABLE_PHOTO_GROUPS = import.meta.env.VITE_ENABLE_PHOTO_GROUPS === 'true';

/** Photo/date steppers in the panorama experience; tablet map/close use the md: variants to match. */
export const PANORAMA_NAV_BUTTON_BOX = 'w-[50px] h-[50px]';
export const PANORAMA_NAV_BUTTON_ICON = 'w-6 h-6';
export const PANORAMA_TABLET_FLOATING_BUTTON_BOX = 'md:w-[50px] md:h-[50px]';
export const PANORAMA_TABLET_FLOATING_ICON = 'md:w-6 md:h-6';
/** Dialog close: match nav at md+ (child `X` is an svg). */
export const PANORAMA_TABLET_DIALOG_CLOSE_CLASS = `${PANORAMA_TABLET_FLOATING_BUTTON_BOX} md:[&_svg]:h-6 md:[&_svg]:w-6`;
/** Map FAB: extra top inset at md+ so it clears the larger dialog close control. */
export const PANORAMA_MAP_BUTTON_WRAPPER_TOP_CLASS =
  'top-[calc(env(safe-area-inset-top,0px)+3.25rem)] md:top-[calc(env(safe-area-inset-top,0px)+4.5rem)]';

export { PITCH_OFFSET, ENABLE_PHOTO_GROUPS };
